var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTwilio(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17495",
    "data-name": "Rectangle 17495",
    width: 40,
    height: 40,
    transform: "translate(900 402)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_474",
    "data-name": "Mask Group 474",
    transform: "translate(-900 -402)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6354",
    "data-name": "Path 6354",
    d: "M18.159,0A18.177,18.177,0,1,1,0,18.177,18.144,18.144,0,0,1,18.159,0Zm0,4.847a13.33,13.33,0,1,0,13.317,13.33A13.285,13.285,0,0,0,18.159,4.847ZM13.68,18.9a3.757,3.757,0,1,1-3.753,3.757A3.774,3.774,0,0,1,13.68,18.9Zm8.959,0a3.757,3.757,0,1,1-3.753,3.757A3.774,3.774,0,0,1,22.638,18.9Zm0-8.967a3.757,3.757,0,1,1-3.753,3.757A3.774,3.774,0,0,1,22.638,9.937Zm-8.959,0a3.757,3.757,0,1,1-3.753,3.757A3.774,3.774,0,0,1,13.68,9.937Z",
    transform: "translate(901.91 404.001)",
    fill: "#f22f46"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwilio);
export default __webpack_public_path__ + "static/media/twilio.3d0a55ea8ed6c31d601c7715b26bfdbe.svg";
export { ForwardRef as ReactComponent };